import React from 'react'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import { defaultLocale } from 'i18n'
import {
  GoogleTagManagerHead,
  GoogleTagManagerBody,
} from 'components/organisms/GoogleTagManager'
import Header from 'containers/organisms/Header'
import Footer from 'components/organisms/Footer'

export default function ErrorTemplate(props) {
  const title = i18n.t(
    `error.${props.status}.title` || 'server.shared.default_title',
  )
  const description = i18n.t(`error.${props.status}.description`) || ''
  const siteName = i18n.t('server.shared.default_site_name')

  function renderRoot() {
    return (
      <div>
        <Header {...props} />
        {props.children}
        <Footer {...props} />
      </div>
    )
  }

  function renderAll() {
    return (
      <html>
        <head>
          <meta charSet="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no"
          />
          <title>{`${title} | ${siteName}`}</title>
          <meta name="description" content={description} />
          <link
            rel="stylesheet"
            href={manifest['account/main.css']}
            media="screen"
          />
          <link
            rel="stylesheet"
            href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
          />
          <link rel="dns-prefetch" href="//account.spacemarket.com" />
          <link
            rel="apple-touch-icon"
            href={imagePath('common/apple-touch-icon.png')}
          />
          <script
            src="https://browser.sentry-cdn.com/4.6.6/bundle.min.js"
            crossOrigin="anonymous"
          />
          <GoogleTagManagerHead />
        </head>
        <body className="site-service">
          <GoogleTagManagerBody />
          <div id="js-root">{renderRoot()}</div>
        </body>
      </html>
    )
  }
  return props.config.SSR ? renderAll() : renderRoot()
}
